import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {withStyles} from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import SearchIcon from "@material-ui/icons/Search";
import {
  setSearchQuery,
  incrementThirdPartySearchPage,
  search,
  clearSearchData
} from "../../../AC/third-party-search";
import {uploaderSelector} from "../../../selectors";
import withErrorBoundary from "../../../decorators/withErrorBoundary";
import {Results} from "./Results";

const styles = () => ({
  input: {
    padding: `14px`
  }
});

export class ThirdPartySearch extends Component {
  static propTypes = {
    source: PropTypes.oneOf(`google-search`, `shutterstock`),
    classes: PropTypes.object,
    uploader: PropTypes.object,
    search: PropTypes.func,
    clearSearchData: PropTypes.func,
    uploadImage: PropTypes.func,
    setSearchQuery: PropTypes.func,
    incrementGoogleSearchPage: PropTypes.func
  };
  textValueRef = React.createRef();
  inputLabels = {
    "google-search": `Искать в Google`,
    "shutterstock": `Искать в ShutterStock`
  };
  handleChange = (event) => {
    this.props.setSearchQuery(event.target.value);
  };
  handleSubmit = (e) => {
    e.preventDefault();
    if (this.props.uploader.query) {
      this.props.search(this.props.source);
    }
  };
  componentDidMount() {
    this.textValueRef.current.focus();
  }
  componentWillUnmount() {
    this.props.clearSearchData();
  }
  render() {
    const {
      classes,
      uploader: {source, query: value}
    } = this.props;
    return (
      <div className="google-search">
        <div className="google-search__header">
          <form onSubmit={this.handleSubmit}>
            <div className="google-search__field">
              <TextField
                inputRef={this.textValueRef}
                label={this.inputLabels[source]}
                value={value}
                placeholder="Например: цветы или мопс"
                onChange={this.handleChange}
                InputProps={{
                  classes: {
                    input: classes.input
                  }
                }}
                variant="outlined"
                fullWidth
              />
              <div className="google-search__button">
                <IconButton
                  variant="contained"
                  color="primary"
                  aria-label="Search"
                  onClick={() => this.props.search(this.props.source)}
                >
                  <SearchIcon />
                </IconButton>
              </div>
            </div>
          </form>
        </div>
        <Results />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  uploader: uploaderSelector(state)
});

const mapDispatchToProps = {
  search,
  setSearchQuery,
  incrementGoogleSearchPage: incrementThirdPartySearchPage,
  clearSearchData
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(withErrorBoundary(ThirdPartySearch)));
